export default "__VITE_ASSET__JPsmdYtI__"